import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { appviaNavContent } from '../extensions/CustomNavContent';

export const appviaNavContentModule = createFrontendModule({
  pluginId: 'app',
  extensions: [appviaNavContent],
});
